








































































import { Component, Vue } from "@/shared/vuepack";
import MessageDetail from "../messageCenter/MessageDetail.vue";
import { useMessageCenterStore } from "@/employee/store/messageCenter";
import moment from "moment";
import { Watch } from "vue-property-decorator";
import {
  FetchState,
  MessageActionType,
  MessageCenterRequest,
  MessageFilterType,
  UpdateMessageRequest
} from "@/shared/types";
import Pill from "@/shared/components/ui/Pill.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner, MessageDetail,
    Pill,
    Pagination}
})
export default class MessageCenter extends Vue {

  messageCenterStore = useMessageCenterStore();
  selectedMessage = null;
  selectedFilter = MessageFilterType.Inbox;
  openDetail = false;
  currentPage = 1;
  isUpdating = false;

  messageFilterType = MessageFilterType;

  messageFilter () {
    return {
      pageNumber: this.currentPage,
      pageSize: 10,
      messageFilter: this.selectedFilter
    };
  }

  mounted () {
    this.messageCenterStore.getMessages(this.messageFilter());
  }

  formatDate (date: string) {
    return moment(date).format("MM/DD/yyyy");
  }

  selectEmail (id: any) {
    if (this.openDetail) {
      this.openDetail = false;
      this.selectedMessage = null;
    }
    this.messageCenterStore.getSelectedMessage(id);
    this.openDetail = true;
  }

  setFilterType (filterType: MessageFilterType) {
    this.selectedFilter = filterType;
    this.currentPage = 1;
    this.messageCenterStore.getFilteredMessages(this.messageFilter());
  }

  setReadValue (id: string, isRead: boolean) {
    if (!this.isUpdating) {
      this.messageCenterStore.markMessageAsRead(id, isRead);
    }
  }

  @Watch("messageCenterStore.messageUpdateFetchState", { deep: true })
  listenForUpdateState () {
    this.isUpdating = this.messageCenterStore.messageUpdateFetchState === FetchState.Loading;
  }

  @Watch("messageCenterStore.selectedMessage", { deep: true })
  setSelectedEmail () {
    if (this.messageCenterStore.messageFetchState === FetchState.Loaded) {
      this.selectedMessage = this.messageCenterStore.selectedMessage;
    }
  }

  onDetailClose () {
    this.openDetail = false;
  }

  onPageChanged (event) {
    this.currentPage = event;
    this.messageCenterStore.getFilteredMessages(this.messageFilter());
  }

  setSaveValue (id: any, value: boolean, archived: boolean) {
    if (!this.isUpdating) {
      const request: UpdateMessageRequest = {
        messageId: id,
        isSaved: value,
        isArchived: archived && value ? !value : archived
      };
      this.messageCenterStore.setMessageSavedOrArchived(request, MessageActionType.Save);
    }
  }

  setArchivedValue (id: number, value: boolean, saved: boolean) {
    if (!this.isUpdating) {
      const request: UpdateMessageRequest = {
        messageId: id,
        isArchived: value,
        isSaved: saved && value ? !value : saved
      };
      this.messageCenterStore.setMessageSavedOrArchived(request, MessageActionType.Archive);
    }
  }
}
